module.exports = __webpack_public_path__ + "static/23-b63725d2cdafcfa4f56ed778005b1dcd.mp4";